module.exports = __webpack_public_path__ + "static/media/upselling-background.2a9ba41d.png";